import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import theme from '../../../styles/theme';

const featherIcon = require('feather-icons');

const ButtonWrapper = styled.button`
  border: none;
  background-color: transparent;
  padding: 0;
  cursor: pointer;

  &:active {
    opacity: 0.7;
  }
`;

const IconWrapper = styled.i`
  display: inline-block;
`;

const IconButton = ({ name, size, strokeWidth, rotate, color, ...props }) => {
  const iconType = {
    primary: theme.colors.primary,
    dark: theme.colors.gray700,
  };

  const shapeStyle = {
    width: size,
    height: size,
    transform: rotate ? `rotate(${rotate}deg)` : undefined,
  };

  const iconStyle = {
    'stroke-width': strokeWidth,
    stroke: Object.keys(iconType).includes(color) ? iconType[color] : color,
    width: size,
    height: size,
    color: Object.keys(iconType).includes(color) ? iconType[color] : color,
  };

  const icon = featherIcon.icons[name];
  const svg = icon ? icon.toSvg(iconStyle) : '';
  const base64 = Buffer.from(svg, 'utf8').toString('base64');

  return (
    <ButtonWrapper {...props}>
      <IconWrapper style={{ ...props.style, ...shapeStyle }}>
        <img src={`data:image/svg+xml;base64,${base64}`} alt={name} />
      </IconWrapper>
    </ButtonWrapper>
  );
};

IconButton.propTypes = {
  name: PropTypes.string,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  rotate: PropTypes.number,
  color: PropTypes.string,
  style: PropTypes.object,
};

IconButton.defaultProps = {
  name: 'bell',
  size: theme.iconSizes.s,
  strokeWidth: 2,
  rotate: 0,
  color: 'dark',
  style: {},
};

export default IconButton;
